<template>
  <v-btn color="pink" dark @click="$emit('click')">Finish</v-btn> 
</template>

<script>
export default {};
</script>

<style>
</style>
